import { Component, Input } from '@angular/core';
import { LoadingIconButtonComponent } from '@app-components/common/loading-icon-button/loading-icon-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-forward-attachment-button',
  templateUrl: './forward-attachment-button.component.html',
  styleUrls: ['./forward-attachment-button.component.scss'],
  imports: [LoadingIconButtonComponent, TranslateModule, MatMenuItem],
})
export class ForwardAttachmentButtonComponent {
  @Input() isMenu = false;
  @Input() disabled: boolean;
  @Input() showButton: boolean;
  @Input() showLoading: boolean;

  constructor() {}
}
